"use server"

import { getAuthHeaders } from "@/lib/data/cookies";
import { sdk } from "@/lib/medusa";
import { AppNotification } from "@/modules/notifications/types";

export async function fetchNotifications(offset = 0, limit = 10) {
  const headers = await getAuthHeaders();
  if (!headers.authorization) return { notifications: [] as AppNotification[], count: 0 };
  
  try {
    const data = await sdk.client.fetch<{ notifications: AppNotification[], count: number }>(
      `/store/notifications`,
      {
        method: "GET",
        headers,
        cache: "no-store",
        query: { offset, limit }
      }
    );
    
    return data;
  } catch (err) {
    console.error("Error fetching notifications:", err);
    return { notifications: [] as AppNotification[], count: 0 };
  }
}

export async function getNotificationToken() {
  const headers = await getAuthHeaders();
  return headers.authorization || null;
}

export async function markNotificationAsRead(id: string) {
  const headers = await getAuthHeaders();
  if (!headers.authorization) return false;
  
  try {
    await sdk.client.fetch(
      `/store/notifications/${id}/read`,
      {
        method: "POST",
        headers,
        cache: "no-store",
      }
    );
    
    return true;
  } catch (err) {
    console.error(`Error marking notification ${id} as read:`, err);
    return false;
  }
}

export async function markAllNotificationsAsRead() {
  const headers = await getAuthHeaders();
  
  try {
    await sdk.client.fetch(
      `/store/notifications/read-all`,
      {
        method: "POST",
        headers,
        cache: "no-store",
      }
    );
    
    return true;
  } catch (err) {
    console.error("Error marking all notifications as read:", err);
    return false;
  }
}
